import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Paper,
  Switch,
  Tab,
  TextField,
  Typography,
} from '@mui/material'
import React, { useState } from 'react'
import AutoCompleteMultiSelect from '../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx'
import TextAreaComponents from '../../components/TextAreaComponents/TextAreaComponents.tsx'
import StickyHeadTable from '../../components/SpecificationTable/Specification.tsx'

function Story(props) {
const [storyDescription, setStoryDescription]=useState(props.ForEdit?props.ForEdit.story:'')
const[DescriptionErr, setDescriptionErr]=useState(false)
const onStoryChange=(story)=>{
  setStoryDescription(story)
  // if(!!props.ForEdit==false){
  //   console.log('sk')
    props.sendStoryToAdditem(story)
  // }
  // else{
  //   var obj ={id:props.ForEdit.id, foodItemId:props.ForEdit.foodItemId ,story:story}
  //   props.sendStoryToAdditem(obj)
  // }
  
}



  return (
    <div>
      <Grid container sx={{ padding: '0.5rem' }}>
        <Grid xs={2}>
          <Typography style={{ paddingTop: '1rem' }}>Description</Typography>
        </Grid>
        <Grid xs={10}>
          <TextAreaComponents id={1} label={'Description'} value={onStoryChange} val={storyDescription}/>
        {/* {DescriptionErr && <span style={{color:'red'}}>This field is required</span>} */}
        </Grid>
      </Grid>

    
    </div>
  )
}

export default Story
